import {memo} from "react";
// local
import {CustomTooltip} from "components/CustomTooltip";
import {
  signContractIdentifyMethod,
  signContractIdentifyMethodOptions,
  signContractAuthenticateStatus,
} from "../../constants";
import {IconSMSVerification, IconBankIDVerification} from "components/icons";
import cn from "classnames";

function participantShowsVerificationIconInIdentifyColumn(participant, method) {
  if (!participant?.isSigned) return false;
  if (method === signContractIdentifyMethod.SMS) {
    return (
      participant.authenticateStatus === signContractAuthenticateStatus.SMS_AUTHENTICATED
    );
  }
  if (method === signContractIdentifyMethod.BANKID) {
    return (
      participant.authenticateStatus ===
      signContractAuthenticateStatus.BANKID_AUTHENTICATED
    );
  }
  return false;
}

export const SignContractIdentifyMethodIconDisplay = memo(({method, participant}) => {
  const option = signContractIdentifyMethodOptions.find((o) => o.value === method);
  const tooltipKey = option?.label;
  const hideIconBecauseShownInActions = participantShowsVerificationIconInIdentifyColumn(
    participant,
    method
  );

  const icon = hideIconBecauseShownInActions ? null : method ===
    signContractIdentifyMethod.BANKID ? (
    <IconBankIDVerification />
  ) : method === signContractIdentifyMethod.SMS ? (
    <IconSMSVerification />
  ) : null;

  return (
    icon && (
      <span
        className={cn(
          "identify-method-icon-display df-row-center fs0",
          hideIconBecauseShownInActions && "identify-method-icon-display--empty"
        )}
      >
        {tooltipKey ? (
          <CustomTooltip text={tooltipKey}>
            <span className="df-row-center ml-2">{icon}</span>
          </CustomTooltip>
        ) : (
          icon
        )}
      </span>
    )
  );
});
